var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * 
 * @file Allows react to render a component in an arbitrary DOM node, in this case in a new window.
 * @author Box
 */

import { PureComponent } from 'react';
import { createPortal } from 'react-dom';

var INTEGRATION_CONTAINER_ID = 'integration-container';

var IntegrationPortal = function (_PureComponent) {
    _inherits(IntegrationPortal, _PureComponent);

    /**
     * [constructor]
     *
     * @private
     * @return {IntegrationPortal}
     */
    function IntegrationPortal(props) {
        _classCallCheck(this, IntegrationPortal);

        var _this = _possibleConstructorReturn(this, (IntegrationPortal.__proto__ || Object.getPrototypeOf(IntegrationPortal)).call(this, props));

        var integrationWindow = _this.props.integrationWindow;

        var existingContainer = integrationWindow.document.querySelector('#' + INTEGRATION_CONTAINER_ID);

        // If the integration window isn't closed, we should reuse the container div and avoid
        // creating another one.
        _this.containerElement = existingContainer || integrationWindow.document.createElement('div');

        _this.containerElement.id = INTEGRATION_CONTAINER_ID;
        return _this;
    }

    /**
     * Setup UI in the new window.
     *
     * @private
     * @inheritdoc
     * @return {void}
     */


    _createClass(IntegrationPortal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var integrationWindow = this.props.integrationWindow;

            this.copyStyles();
            integrationWindow.document.body.appendChild(this.containerElement);
        }

        /**
         * Copies stylesheets to the new window.
         *
         * @private
         * @return {void}
         */

    }, {
        key: 'copyStyles',
        value: function copyStyles() {
            var integrationWindow = this.props.integrationWindow;
            // The new window will have no CSS, so we copy all style sheets as a safe way
            // of ensuring required styles are present

            Array.from(document.styleSheets).forEach(function (styleSheet) {
                if (!styleSheet.href) {
                    return;
                }

                var copiedStyleSheet = integrationWindow.document.createElement('link');
                copiedStyleSheet.rel = 'stylesheet';
                copiedStyleSheet.href = styleSheet.href;
                integrationWindow.document.head.appendChild(copiedStyleSheet);
            });

            // Reset margin and padding in our new window
            integrationWindow.document.body.style.margin = 0;
            integrationWindow.document.body.style.padding = 0;
        }
    }, {
        key: 'render',
        value: function render() {
            return createPortal(this.props.children, this.containerElement);
        }
    }]);

    return IntegrationPortal;
}(PureComponent);

export default IntegrationPortal;